export enum CardWidthValues {
  SMALL = '300',
  MEDIUM = '400',
  NORMAL = '500',
  WIDE = '560',
}
